var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('ScheduleListByStaffComponent',{attrs:{"typeName":"巡回清掃","type":2,"settionStrageName":"RoundSlbsStorageItemName","checkListDate":_vm.checkListDate,"userId":_vm.userId,"name":_vm.name,"routerName":"RoundCheckListTable"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }